import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { createLoginFormSchema } from './loginSchema';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

type LoginFormValues = z.infer<ReturnType<typeof createLoginFormSchema>>;

const useLoginForm = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const schema = createLoginFormSchema(t);

  // Get email from query parameter
  const emailFromQuery = searchParams.get('your-email') || '';

  const form = useForm<LoginFormValues>({
    mode: 'onSubmit',
    resolver: zodResolver(schema),
    defaultValues: {
      login: emailFromQuery,
      password: '',
    },
  });

  // Update error messages after changing the language
  useEffect(() => {
    if (form.formState.isSubmitted) {
      form.trigger();
    }
  }, [t]);

  return {
    form,
  };
};

export { useLoginForm, type LoginFormValues };
